<script>

import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {},
  props: {
    person: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  beforeMount() {
    if (!this.person.birth_date) {
      this.person.birth_date = {
        day: null,
        month: null,
        year: null,
      }
    }
    if (!this.person.death_date) {
      this.person.death_date = {
        day: null,
        month: null,
        year: null,
      }
    }
  },
  methods: {
    async submitForm() {
      api.save('persons', this.person)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
  }
};
</script>

<template>

  <b-form>
    <b-card no-body class="mb-2 pt-2">
      <b-card-body class="p-0">
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Nom" label-for="formrow-nom-input">
              <b-form-input id="formrow-nom-input" type="text"
                            v-model="person.last_name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Prénom" label-for="formrow-prenom-input">
              <b-form-input id="formrow-prenom-input" type="text"
                            v-model="person.first_name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Nom de naissance" label-for="formrow-nom_naissance-input">
              <b-form-input id="formrow-nom_naissance-input" type="text"
                            v-model="person.birth_name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Surnom" label-for="formrow-surnom-input">
              <b-form-input id="formrow-surnom-input" type="text"
                            v-model="person.surname"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Relation" label-for="formrow-relation-input">
              <b-form-input id="formrow-relation-input" type="text"
                            v-model="person.relatives"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Jour de naissance" label-for="formrow-jour_naissance-input">
              <b-form-input id="formrow-jour_naissance-input" type="number" min="0" max="31"
                            v-model="person.birth_date.day"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Mois de naissance" label-for="formrow-mois_naissance-input">
              <b-form-input id="formrow-mois_naissance-input" type="number" min="0" max="12"
                            v-model="person.birth_date.month"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Année de naissance" label-for="formrow-annee_naissance-input">
              <b-form-input id="formrow-annee_naissance-input" type="number" min="0"
                            v-model="person.birth_date.year"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Jour de décès" label-for="formrow-jour_deces-input">
              <b-form-input id="formrow-jour_deces-input" type="number" min="0" max="31"
                            v-model="person.death_date.day"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Mois de décès" label-for="formrow-mois_deces-input">
              <b-form-input id="formrow-mois_deces-input" type="number" min="0" max="12"
                            v-model="person.death_date.month"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Année de décès" label-for="formrow-annee_deces-input">
              <b-form-input id="formrow-annee_deces-input" type="number" min="0"
                            v-model="person.death_date.year"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Détails" label-for="formrow-details-input">
              <b-form-textarea id="formrow-details-input"
                            v-model="person.details"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

      </b-card-body>
    </b-card>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>